import { render, staticRenderFns } from "./CatalogAchizitionsSelect.vue?vue&type=template&id=425aeb78"
import script from "./CatalogAchizitionsSelect.vue?vue&type=script&lang=js"
export * from "./CatalogAchizitionsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports